var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 16",
    width: "20px",
    className: "css-13o7eu2 e16cqoze0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.31 3.04a.58.58 0 000 .83 5.86 5.86 0 01.08 8.14.58.58 0 00.43.98c.16 0 .32-.06.43-.19a7.04 7.04 0 00-.1-9.74.59.59 0 00-.84-.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.77.34a.59.59 0 00-.82-.05.58.58 0 00-.05.82 10.35 10.35 0 01.08 13.66c-.21.24-.19.61.06.82a.58.58 0 00.83-.06 11.51 11.51 0 00-.1-15.2M9.93 15.83a.6.6 0 01-.32-.1l-4.62-4.65H.75a.58.58 0 01-.57-.58V4.67c0-.32.25-.58.57-.58h4.24L9.61.1c.18-.12.4-.13.59-.03.19.1.3.3.3.51v14.66a.58.58 0 01-.57.58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.1b3f183f50a283cc9d30ac8aab9169f0.svg";
export { ForwardRef as ReactComponent };